/**
 * Component Lazy Loaders
 * Route-level and feature-level code splitting
 */

import { createLazyComponent } from './core';

// =============================================================================
// PAGE COMPONENT LAZY LOADERS (Route-Level Code Splitting)
// =============================================================================

export const LazyCreateRecipePage = createLazyComponent(
  () => import('../../pages/CreateRecipePage').then(m => ({ default: m.CreateRecipePage })),
  { preloadTrigger: 'hover', preloadDelay: 200 }
);

export const LazySearchPage = createLazyComponent(
  () => import('../../pages/SearchPage').then(m => ({ default: m.SearchPage })),
  { preloadTrigger: 'hover', preloadDelay: 200 }
);

export const LazyMealPlannerPage = createLazyComponent(
  () => import('../../pages/MealPlannerPage'),
  { preloadTrigger: 'hover', preloadDelay: 300 }
);

export const LazyShoppingListPage = createLazyComponent(
  () => import('../../pages/ShoppingListPage'),
  { preloadTrigger: 'hover', preloadDelay: 200 }
);

export const LazyFavoritesPage = createLazyComponent(
  () => import('../../pages/FavoritesPage').then(m => ({ default: m.FavoritesPage })),
  { preloadTrigger: 'hover', preloadDelay: 200 }
);

export const LazyProfilePage = createLazyComponent(
  () => import('../../pages/ProfilePage').then(m => ({ default: m.ProfilePage })),
  { preloadTrigger: 'hover', preloadDelay: 200 }
);

// AndroidDrawerDemo removed to reduce bundle size

// =============================================================================
// FEATURE COMPONENT LAZY LOADERS (Feature-Level Code Splitting)
// =============================================================================

export const LazyRecipeForm = createLazyComponent(
  () => import('../../components/RecipeForm').then(m => ({ default: m.RecipeForm })),
  { preloadTrigger: 'hover', preloadDelay: 300 }
);

export const LazyInstructionEditor = createLazyComponent(
  () => import('../../components/InstructionEditor').then(m => ({ default: m.InstructionEditor })),
  { preloadTrigger: 'interaction', preloadDelay: 100 }
);

export const LazyMealPlanningView = createLazyComponent(
  () => import('../../components/MealPlanning/MealPlanningView').then(m => ({ default: m.MealPlanningView })),
  { preloadTrigger: 'visible', preloadDelay: 400 }
);

export const LazyAdvancedRecipePicker = createLazyComponent(
  () => import('../../components/AdvancedRecipePicker').then(m => ({ default: m.AdvancedRecipePicker })),
  { preloadTrigger: 'interaction', preloadDelay: 300 }
);

export const LazyRecipeListWithVirtualization = createLazyComponent(
  () => import('../../components/OptimizedRecipeList'),
  { preloadTrigger: 'visible', preloadDelay: 200 }
);

// =============================================================================
// AUTH COMPONENT LAZY LOADERS (Security-Critical Chunks)
// =============================================================================

export const LazyAuthRoutes = createLazyComponent(
  () => import('../../routes/AuthRoutes').then(m => ({ default: m.AuthRoutes })),
  { preloadTrigger: 'hover', preloadDelay: 150 }
);

export const LazyLoginForm = createLazyComponent(
  () => import('../../components/LoginForm').then(m => ({ default: m.LoginForm })),
  { preloadTrigger: 'visible', preloadDelay: 100 }
);

// =============================================================================
// SERVICE LAYER LAZY LOADERS (Heavy Business Logic)
// =============================================================================

export const LazyDataProvider = createLazyComponent(
  () => import('../../components/DataProvider').then(m => ({ default: m.DataProvider })),
  { preloadDelay: 0 } // Load immediately but lazily
);

export const LazyPerformanceMonitor = createLazyComponent(
  () => import('../../components/PerformanceMonitor').then(m => ({ default: m.PerformanceMonitor })),
  { preloadDelay: 1000 } // Load after initial render
);